var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[(_vm.showPic)?_c('img',{staticClass:"empty-image",attrs:{"src":require("@/assets/images/pic_zanwushuju.png"),"alt":"暂无数据"}}):_vm._e(),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.$t('public.noData') || '暂无数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }